module.exports = {"511402001":"通惠街道","511402002":"大石桥街道","511402003":"苏祠街道","511402100":"白马镇","511402101":"象耳镇","511402102":"太和镇","511402103":"悦兴镇","511402104":"尚义镇","511402105":"多悦镇","511402106":"秦家镇","511402107":"万胜镇","511402108":"崇仁镇","511402109":"思蒙镇","511402110":"修文镇","511402112":"松江镇","511402113":"崇礼镇","511402114":"富牛镇","511402115":"永寿镇","511402116":"三苏镇","511402205":"广济乡","511402206":"盘鳌乡","511402210":"土地乡","511402211":"复盛乡","511402212":"复兴乡","511402213":"金花乡","511402214":"柳圣乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511402.json
// module id = 2349
// module chunks = 0